import { WifiOff } from 'lucide-react';
import { usePWA } from '../hooks/usePWA';

export default function OfflineBanner() {
  const { isOnline } = usePWA();

  if (isOnline) {
    return null;
  }

  return (
    <aside
      aria-label="Offline Mode"
      className="bg-amber-500 text-slate-950 px-4 py-2 text-xs font-bold flex items-center justify-center gap-2 shadow-sm sticky top-0 z-50 animate-in fade-in slide-in-from-top-2"
    >
      <WifiOff className="w-4 h-4 shrink-0" />
      <span>
        You are currently offline. Live payment requests and ledger updates will resume when
        reconnected.
      </span>
    </aside>
  );
}
